import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { MatchScoreWidget } from "../../../../frontend/templates/_partials/MatchScoreWidget/Index";
import borderFrame from '../../../../frontend/templates/fcb/ResultsNew/images/border_BG_empty.png'
import getContentById from "../../../utils/getContentById";
import { formatMinute, parseMinute, sortByTimeFirst } from "../../../../frontend/templates/fcb/ResultsNew/Index";
import { PresetColors } from "./LeftSidebar/EditTab";
import { uefaID } from "../../../../frontend/templates/fcb/ImageTable/Index";

const FCBResultContent = ({ data, ...props }) => {
    const templateName = data?.template_name ?? "";
    const id = `${templateName}_${data?.uuid}`;
    const manualEntries = props.manualEntries;
    const jersey = props.jersey;
    const time = props.time;
    const isPenalty = props.isPenalty;
    const { options, fields, dynamic, editData } = data.data;
    const {
        matchDetails = {},
        goalShots,
        lineUp,
        matchInfo,
    } = data?.data?.dynamic;

    const matchStatus = matchDetails?.matchStatus;
    const scores = matchDetails?.scores || {
        total: {
            home: null,
            away: null
        }
    };
    const homeTeam = data.event.home;
    const awayTeam = data.event.away;
    let currentMatchTime = matchDetails?.matchTime ?? matchDetails?.matchLengthMin ?? 0;
    const period = matchDetails?.period;
    let firstHalfExtra = 0;
    if (period) {
        firstHalfExtra = period?.[0].announcedInjuryTime / 60 ?? 0;
    }
    if (firstHalfExtra > 0) {
        currentMatchTime -= firstHalfExtra;
    }

    const goals = goalShots?.filter(({ typeId }) => typeId === 16);
    const homeScore = getContentById("homeScore", fields);
    const awayScore = getContentById("awayScore", fields);
    let showScore = true;

    if (!_.isEmpty(homeScore)) {
        _.set(scores, 'total.home', homeScore);
        showScore = true
    }

    if (!_.isEmpty(awayScore)) {
        _.set(scores, 'total.away', awayScore);
        showScore = true
    }

    const competitionId = matchInfo?.competition?.id;
    const homeKit = lineUp?.find(
        ({ contestantId }) => contestantId === homeTeam.id,
    )?.player;
    const awayKit = lineUp?.find(
        ({ contestantId }) => contestantId === awayTeam.id,
    )?.player;

    let homeGoalGroup;
    let homeGoalsFlat;
    let totalHomeGoals = 0;
    let awayGoalGroup;
    let awayGoalsFlat;
    let totalAwayGoals = 0;


    if (manualEntries && (manualEntries?.scores?.home || manualEntries?.scores?.away)) {
        homeGoalsFlat = manualEntries?.players?.home
            ?.filter((g) => g.min && g.name)
            .map((g) => ({
                playerName: g.name,
                timeMin: g.min,
                sortValue: parseMinute(g.min),
            }))
            .sort((a, b) => a.sortValue - b.sortValue) || [];

        totalHomeGoals = homeGoalsFlat.length;
        homeGoalGroup = Object.values(manualEntries?.players?.home?.reduce((acc, goal) => {
            if (!acc[goal.name] && goal.min && goal.name) {
                acc[goal.name] = {
                    playerName: goal.name,
                    times: [],
                };
            }
            if (goal.min && goal.name) {
                acc[goal.name].times.push(goal.min);
            }
            return acc;
        }, {}));

        homeGoalGroup = sortByTimeFirst(homeGoalGroup);

        awayGoalsFlat = manualEntries?.players?.away
            ?.filter((g) => g.min && g.name)
            .map((g) => ({
                playerName: g.name,
                timeMin: g.min,
                sortValue: parseMinute(g.min),
            }))
            .sort((a, b) => a.sortValue - b.sortValue) || [];

        totalAwayGoals = awayGoalsFlat.length;

        awayGoalGroup = Object.values(manualEntries?.players?.away?.reduce((acc, goal) => {
            if (!acc[goal.name] && goal.min && goal.name) {
                acc[goal.name] = {
                    playerName: goal.name,
                    times: [],
                };
            }
            if (goal.min && goal.name) {
                acc[goal.name].times.push(goal.min);
            }
            return acc;
        }, {}));

        awayGoalGroup = sortByTimeFirst(awayGoalGroup);
    } else {
        // homeGoalsFlat = goals
        //     .filter(g => (g.contestantId === homeTeam.id && !g.isOwnGoal) || (g.contestantId !== homeTeam.id && g.isOwnGoal))
        //     .map(g => {
        //         let p = homeKit.find(k => k.playerId === g.playerId);
        //         if (g.isOwnGoal) {
        //             p = awayKit.find(k => k.playerId === g.playerId);
        //         }
        //         return {
        //             playerId: g.playerId,
        //             playerName: (p?.shortLastName || g.playerName) + (g.isPenalty ? " (P)" : g.isOwnGoal ? " (OG)" : ""),
        //             timeMin: g.timeMin,
        //             sortValue: parseMinute(g.timeMin),
        //         };
        //     })
        //     .sort((a, b) => a.sortValue - b.sortValue);

        // totalHomeGoals = homeGoalsFlat.length;

        // homeGoalGroup = Object.values(
        //     goals.reduce((acc, goal) => {
        //         const isHome = (goal.contestantId === homeTeam.id && !goal.isOwnGoal) || (goal.contestantId !== homeTeam.id && goal.isOwnGoal);

        //         if (isHome) {
        //             if (!acc[goal.playerId]) {
        //                 let _player = homeKit.find((k) => k.playerId === goal.playerId);
        //                 if (goal.isOwnGoal) {
        //                     _player = awayKit.find((k) => k.playerId === goal.playerId);
        //                 }

        //                 acc[goal.playerId] = {
        //                     playerName: _player?.shortLastName || goal.playerName,
        //                     times: [],
        //                     isPenalty: goal.isPenalty,
        //                     isOwnGoal: goal.isOwnGoal
        //                 };
        //             }
        //             acc[goal.playerId].times.push((goal.timeMin) + (goal.isPenalty ? " (P)" : goal.isOwnGoal ? " (OG)" : ""));
        //         }

        //         return acc;
        //     }, {}),
        // );

        // awayGoalsFlat = goals
        //     .filter(g => (g.contestantId !== homeTeam.id && !g.isOwnGoal) || (g.contestantId === homeTeam.id && g.isOwnGoal))
        //     .map(g => {
        //         let p = awayKit.find(k => k.playerId === g.playerId);
        //         if (g.isOwnGoal) {
        //             p = homeKit.find(k => k.playerId === g.playerId);
        //         }
        //         return {
        //             playerId: g.playerId,
        //             playerName: (p?.shortLastName || g.playerName) + (g.isPenalty ? " (P)" : g.isOwnGoal ? " (OG)" : ""),
        //             timeMin: g.timeMin,
        //             sortValue: parseMinute(g.timeMin),
        //         };
        //     })
        //     .sort((a, b) => a.sortValue - b.sortValue);

        // totalAwayGoals = awayGoalsFlat.length;

        // awayGoalGroup = Object.values(
        //     goals.reduce((acc, goal) => {
        //         const isHome = goal.contestantId === homeTeam.id;

        //         if (!isHome) {
        //             if (!acc[goal.playerId]) {
        //                 let _player = awayKit.find((k) => k.playerId === goal.playerId);
        //                 if (goal.isOwnGoal) {
        //                     _player = homeKit.find((k) => k.playerId === goal.playerId);
        //                 }
        //                 acc[goal.playerId] = {
        //                     playerName: _player?.shortLastName || goal.playerName,
        //                     times: [],
        //                 };
        //             }
        //             acc[goal.playerId].times.push((goal.timeMin) + (goal.isPenalty ? " (P)" : goal.isOwnGoal ? " (OG)" : ""));
        //         }

        //         return acc;
        //     }, {}),
        // )
    }
    const awayContainerRef = useRef(null);
    const homeContainerRef = useRef(null);

    // compute which items should show a comma after them
    const updateHomeCommas = () => {
        const homeContainer = homeContainerRef.current;
        if (!homeContainer) return;
        const items = Array.from(homeContainer.querySelectorAll(".goal-info"));
        // clear previous flags
        items.forEach(item => item.classList.remove("show-comma"));

        for (let i = 0; i < items.length - 1; i++) {
            const el = items[i];
            const next = items[i + 1];
            // compare y position (top). Use getBoundingClientRect for sub-pixel accuracy.
            const topA = Math.round(el.getBoundingClientRect().top);
            const topB = Math.round(next.getBoundingClientRect().top);
            if (topA === topB) {
                // same row -> show comma after this element
                el.classList.add("show-comma");
            }
        }
    };

    // compute which items should show a comma after them
    const updateAwayCommas = () => {
        const awayContainer = awayContainerRef.current;
        if (!awayContainer) return;
        const items = Array.from(awayContainer.querySelectorAll(".goal-info"));
        // clear previous flags
        items.forEach(item => item.classList.remove("show-comma"));

        for (let i = 0; i < items.length - 1; i++) {
            const el = items[i];
            const next = items[i + 1];
            // compare y position (top). Use getBoundingClientRect for sub-pixel accuracy.
            const topA = Math.round(el.getBoundingClientRect().top);
            const topB = Math.round(next.getBoundingClientRect().top);
            if (topA === topB) {
                // same row -> show comma after this element
                el.classList.add("show-comma");
            }
        }
    };

    useEffect(() => {
        updateHomeCommas();
        updateAwayCommas();
        // catch layout changes when fonts or images load
        window.addEventListener("load", updateHomeCommas);
        window.addEventListener("load", updateAwayCommas);

        // If the goalGroups change, re-run (good to watch props; rerun effect)
        return () => {
            window.removeEventListener("load", updateHomeCommas);
            window.removeEventListener("load", updateAwayCommas);
        };
    }, [homeGoalGroup, awayGoalGroup]);
    return (
        <div className="preview-wc-content" style={{ zIndex: 101, }}>
            <div className="content">
                <div className={`angled-border ${jersey === PresetColors.white ? "angle-border-white" : jersey === PresetColors.red ? "angle-border-red" : "angle-border-black"}`}>
                    <img src={borderFrame} alt="border-frame" />
                </div>
                <div className="goal-block">
                    <MatchScoreWidget
                        homeTeam={homeTeam}
                        awayTeam={awayTeam}
                        scores={manualEntries ? { total: { ...manualEntries.scores } } : scores}
                        matchStatus={matchStatus}
                        matchDetails={matchDetails}
                        competitionId={competitionId}
                        matchInfo={matchInfo}
                        showScore={showScore}
                    />
                    <div className="goals">
                        <div
                            className={`home ${homeGoalGroup?.length < 4 ? "direction-column" : "direction-row"}`}
                            ref={homeContainerRef}
                        >
                            {
                                totalHomeGoals <= 4 ? homeGoalsFlat?.map((goal, index) => {
                                    return (
                                        <div className="goal-info" key={index}>
                                            <span className="name">{goal.playerName}</span>
                                            <span className="time">{formatMinute(goal.timeMin)}</span>
                                        </div>
                                    )
                                }) : homeGoalGroup?.map((goalGroup, index) => {
                                    const formatted = goalGroup.times.map(formatMinute).join(', ');
                                    return (
                                        <div className="goal-info" key={index}>
                                            <span className="name">{goalGroup.playerName}</span>
                                            <span className="time">
                                                {formatted}
                                            </span>
                                        </div>
                                    );
                                })
                            }
                        </div>
                        <div className="spaceText"></div>
                        {
                            isPenalty && <div className="penalty-container">
                                <div className="penalty-score">
                                    ({manualEntries?.scores?.penHome}-{manualEntries?.scores?.penAway})
                                </div>
                                <div className="penalty-label">
                                    PEN.
                                </div>
                            </div>
                        }
                        <div
                            className={`away ${awayGoalGroup?.length < 4 ? "direction-column" : "direction-row"}`}
                            ref={awayContainerRef}
                        >
                            {
                                totalAwayGoals <= 4 ? awayGoalsFlat?.map((goal, index) => {
                                    return (
                                        <div className="goal-info" key={index}>
                                            <span className="time">{formatMinute(goal.timeMin)}</span>
                                            <span className="name">{goal.playerName}</span>

                                        </div>
                                    )
                                }) : awayGoalGroup?.map((goalGroup, index) => {
                                    const formatted = goalGroup.times.map(formatMinute).join(', ');
                                    return (
                                        <div className="goal-info" key={index}>
                                            <span className="time">
                                                {formatted}
                                            </span>
                                            <span className="name">{goalGroup.playerName}</span>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                    <div className="match-length">
                        {
                            time
                        }'
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FCBResultContent;
